<template>
  <div>
    <section>
      <div class="group">
        <div class="legend">Acesso</div>
        <div class="value">{{ subscription.plan.name }}</div>
        <div class="value">
          <span class="status">Status: <u>{{ subscription.status_label }}</u></span>
        </div>
      </div>

      <div class="group">
        <div class="legend">Descrição</div>
        <div class="value">{{ subscription.plan.description }}</div>
      </div>

      <div
        class="group"
        v-if="!isCanceled"
      >
        <div class="legend">Acesso</div>

        <div
          v-if="subscription.is_lifetime"
          class="value"
        >
          Seu acesso é <b>Vitalício</b
        ></div>

        <div
          v-else-if="subscription.is_staff"
          class="value"
        >
          Você é <b>Membro da Equipe CyberClass</b
        ></div>

        <!-- <div
          v-else
          class="value">Acesso total até <b><u>{{ dateFormat }}</u></b></div> -->
      </div>

      <div
        class="group bg-danger"
        v-else-if="subscription.next_charge_at"
      >
        <div class="value text-white">Pacote de acesso <u>cancelado</u>. Você ainda terá <b>acesso total</b> à plataforma até <b><u>{{ dateFormat }}</u></b></div>
      </div>

        <div
          v-if="!isCanceled"
          class="py-3 text-center"
        >
          <router-link :to="{ name: 'cancellation.subscription' }">
            Cancelar assinatura
          </router-link>
        </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'moment/locale/pt'
  import moment from 'moment'

  export default {
    computed: {
      ...mapGetters('subscription', ['subscription']),

      dateFormat () {
        return moment(this.subscription.next_charge_at).format('D [de] MMMM [de] YYYY')
      },

      isCanceled () {
        return this.subscription.status == 'canceled' || this.subscription.canceled_at
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  section {
    .group:not(:last-child) {
      margin-bottom: 16px;
    }

    .group {
      background-color: $purple700;
      padding: 16px;
      border-radius: 8px;
      border: 1px solid #FFFFFF1A;
    }

    .legend {
      font-size: 0.89rem;
      color: $white100;
    }

    .value {
      .status {
        color: $highlightPrimaryColor;
      }
    }
  }
</style>